// Mock data for Randovate Labs website

export const companyData = {
  name: "Randovate Labs",
  tagline: "Innovation That Protects the Future",
  description: "Randovate Labs is a dynamic and forward-thinking company established in 2026, headquartered in Malaysia. A sister company of an established Indian corporate, leveraging existing industry expertise and business strengths.",
  
  hero: {
    title: "Innovation That Protects the Future",
    subtitle: "Your Trusted Insurance Partner",
    description: "We are a team of highly skilled professionals with deep expertise in the Insurance Domain, delivering exceptional, tailored services to drive measurable outcomes."
  },
  
  clients: [
    { 
      name: "Tokio Marine", 
      logo: "https://companieslogo.com/img/orig/8766.T-3f7693c4.png?t=1720244490"
    },
    { 
      name: "Etiqa", 
      logo: "https://images.seeklogo.com/logo-png/22/1/etiqa-logo-png_seeklogo-225946.png"
    },
    { 
      name: "FWD", 
      logo: "https://companieslogo.com/img/orig/fwd.png"
    },
    { 
      name: "Prudential", 
      logo: "https://companieslogo.com/img/orig/PUK_BIG-ffb1b1d9.png?t=1729229413"
    }
  ],
  
  advantages: [
    {
      number: "01",
      title: "100% Focus on Insurance Domain",
      description: "Deep specialization in insurance technology and business processes"
    },
    {
      number: "02",
      title: "Agile & Responsive",
      description: "Quick turnaround times and adaptive to your changing needs"
    },
    {
      number: "03",
      title: "Transparent Communication",
      description: "Clear, honest dialogue throughout every project phase"
    },
    {
      number: "04",
      title: "Competitive Pricing with Premium Quality",
      description: "Exceptional value without compromising on excellence"
    },
    {
      number: "05",
      title: "Proven Track Record",
      description: "Successful delivery for leading insurance companies"
    }
  ],
  
  commitments: [
    "Client satisfaction",
    "Long-term partnerships",
    "Continuous investment in talent & technology",
    "Ethical business practices",
    "Data security & confidentiality",
    "Compliance with global standards"
  ],
  
  services: {
    technology: [
      {
        title: "Insurance IT Consulting",
        description: "Strategic guidance for technology transformation in insurance operations"
      },
      {
        title: "Core System Modernization",
        description: "Upgrade legacy systems with cutting-edge, scalable solutions"
      },
      {
        title: "Digital Transformation",
        description: "End-to-end digitization of insurance processes and customer journeys"
      },
      {
        title: "Data Analytics & Reporting",
        description: "Advanced analytics for informed decision-making and insights"
      },
      {
        title: "API Integration & Modernization",
        description: "Seamless connectivity between systems and third-party services"
      }
    ],
    business: [
      {
        title: "Underwriting Support Services",
        description: "Comprehensive support for risk assessment and policy underwriting"
      },
      {
        title: "Claims Process Optimization",
        description: "Streamline claims handling for faster, accurate resolutions"
      },
      {
        title: "Policy Administration",
        description: "Efficient management of policy lifecycles and customer data"
      },
      {
        title: "Actuarial Support",
        description: "Expert analysis for pricing, reserving, and risk modeling"
      },
      {
        title: "Regulatory Compliance Advisory",
        description: "Navigate complex regulations with confidence and expertise"
      },
      {
        title: "Business Process Outsourcing",
        description: "Scalable BPO solutions tailored for insurance operations"
      }
    ]
  },
  
  about: {
    mission: "We combine domain knowledge, technical expertise, and a client-first mindset to drive measurable outcomes for our partners across the insurance value chain.",
    expertise: [
      "Highly experienced team of insurance specialists",
      "Continuous learning & upskilling culture",
      "Cross-functional expertise across IT & business"
    ]
  }
};